const routes = [
  {
    index: true,
    label: 'Gilberto Recupito',
    path: '/',
  },
  {
    label: 'Publications',
    path: '/projects',
  },
  {
    label: 'Professional Service',
    path: '/service',
  },
  {
    label: 'Teaching',
    path: '/teaching',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
